import React, { useState } from "react";
import { Link } from "react-router-dom";
import Side from "./Side";
import httpService from "../../../services/httpServices/httpServices";
import validationRegister from "../../../validtions/forms/auth/register";
import helperSpinner from "../../../helpers/spinner";
import SignInWithGoogle from "./SignInWithGoogle";

const Register = () => {
  const [message, setMessage] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    if (!params.has("status")) {
      return;
    }
    if (params.get("status") === "false") {
      return {
        type_class: "alert alert-danger m-0",
        text: params.get("message"),
        class_icon: "fa fa-exclamation-triangle",
      };
    }
  });
  let messageTag;

  if (message) {
    messageTag = (
      <div className="col-12 col-md-12 col-sm-12 col-lg-12 col-xl-12 py-3">
        <div className={`${message.type_class}`}>
          <i className={`${message.class_icon} pl-2`}></i>
          <span>{message.text}</span>
        </div>
      </div>
    );
  }
  const sendForm = async (e) => {
    e.preventDefault();
    const data = getDataForm();

    if (!data) {
      return;
    }
    delete data.repeat_password;
    helperSpinner.showSpinner(helperSpinner.CONTAINER_AUTH_PAGE);
    const resultRegisterUser = await sendRequestRegisterUser(data);
    helperSpinner.removeSpinner(helperSpinner.CONTAINER_AUTH_PAGE);
    if (!resultRegisterUser) {
      return;
    }

    localStorage.setItem("token", resultRegisterUser);
    const url = process.env.REACT_APP_DOMAIN;
    window.location.replace(url);
  };

  const getHeaderForRequest = () => {
    const headersRequest = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };
  const sendRequestRegisterUser = async (userData) => {
    const headersRequest = getHeaderForRequest();
    let result;
    try {
      result = await httpService.postRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/auth/register",
        userData,
        headersRequest
      );
    } catch (error) {
      setMessage({
        type_class: "alert alert-danger m-0",
        text: error.response.data.message,
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }

    return result.data.data;
  };

  const getDataForm = () => {
    const dataInputs = {
      first_name: document.querySelector("#first-name").value,
      last_name: document.querySelector("#last-name").value,
      email: document.querySelector("#email").value,
      mobile: document.querySelector("#mobile").value,
      password: document.querySelector("#password").value,
      repeat_password: document.querySelector("#repeat-password").value,
    };
    if (validationRegister(dataInputs) != true) {
      setMessage({
        type_class: "alert alert-danger m-0",
        text: validationRegister(dataInputs),
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }

    return dataInputs;
  };

  return (
    <div
      className="ltr container-fluid container-auth-page"
      id="container-auth-page"
    >
      <div className="row h-100">
        <Side />
        <div
          className="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8 h-lg-100 py-5 p-lg-0"
          id="container-auth-page-box"
        >
          <div className="d-flex flex-column align-items-center justify-content-center h-100">
            <div id="auth-page-box">
              <div className="border-radius-auth-page">
                <div className="header-box border-radius-auth-page py-1 px-3">
                  ثبت نام
                </div>
                <div className="body-box d-flex flex-column pt-5 pb-2 px-3">
                  <div className="login-auth-page-box">
                    <div className="d-flex ">
                      <div className="w-50 p-2">
                        <SignInWithGoogle
                          redirectUri={`${process.env.REACT_APP_DOMAIN_API}/v1/auth/register-with-google`}
                        />
                      </div>

                      <div className="d-flex align-items-center justify-content-center tab-login-with-hilite-auth-page w-50 pt-2 pr-2 ">
                        <div className="d-flex align-items-center justify-content-center w-100 h-100  p-2 ">
                          <div>با هایلایت</div>
                        </div>
                      </div>
                    </div>
                    <div className="px-2 form-login-with-hilite-auth-page">
                      <div className="px-2">
                        <form onSubmit={sendForm} dir="rtl">
                          <div className="container">
                            <div className="row">
                              {messageTag}
                              <div className="col-12 col-md-12 col-sm-12 col-lg-6 col-xl-6">
                                <div className="p-2">
                                  <input
                                    type="text"
                                    className="form-control form-control-hilite w-100"
                                    placeholder="نام"
                                    id="first-name"
                                    required
                                  />
                                </div>
                              </div>
                              <div className="col-12 col-md-12 col-sm-12 col-lg-6 col-xl-6">
                                <div className="p-2">
                                  <input
                                    type="text"
                                    className="form-control form-control-hilite w-100"
                                    placeholder="نام خانوادگی"
                                    id="last-name"
                                    required
                                  />
                                </div>
                              </div>
                              <div className="col-12 col-md-12 col-sm-12 col-lg-6 col-xl-6">
                                <div className="p-2">
                                  <input
                                    type="email"
                                    className="form-control form-control-hilite w-100"
                                    placeholder="ایمیل"
                                    id="email"
                                    required
                                  />
                                </div>
                              </div>
                              <div className="col-12 col-md-12 col-sm-12 col-lg-6 col-xl-6">
                                <div className="p-2">
                                  <input
                                    type="text"
                                    className="form-control form-control-hilite w-100"
                                    placeholder="موبایل"
                                    id="mobile"
                                    required
                                  />
                                </div>
                              </div>
                              <div className="col-12 col-md-12 col-sm-12 col-lg-6 col-xl-6">
                                <div className="p-2">
                                  <input
                                    type="password"
                                    className="form-control form-control-hilite w-100"
                                    placeholder="رمز عبور"
                                    id="password"
                                    required
                                  />
                                </div>
                              </div>
                              <div className="col-12 col-md-12 col-sm-12 col-lg-6 col-xl-6">
                                <div className="p-2">
                                  <input
                                    type="password"
                                    className="form-control form-control-hilite w-100"
                                    placeholder="تکرار رمز عبور"
                                    id="repeat-password"
                                    required
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="d-flex py-3">
                            <button
                              type="submit"
                              className="btn btn-hilite-1 w-100 border-radius-auth-page"
                            >
                              ثبت نام
                            </button>
                          </div>
                          <div className="py-2">
                            <p className="m-0 text-justify">
                              با ثبت نام در هایلایت ,{" "}
                              <Link className="text-link-hilite px-1" to="/">
                                شرایط رازداری و حفظ حریم خصوصی
                              </Link>{" "}
                              و
                              <a
                                className="text-link-hilite px-1"
                                target="_blank"
                                href="https://hilite.ir/wp-content/uploads/2023/02/terms-of-services.pdf"
                              >
                                شرایط استفاده از خدمات
                              </a>{" "}
                              موافقت میکنید.
                            </p>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                  <div className="py-1">
                    <span className="pl-2">قبلا ثبت نام کردید؟</span>
                    <span>
                      <Link to="/login" className="text-link-hilite">
                        ورود به حساب کاربری
                      </Link>
                    </span>
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-between pt-1">
                <span>info@hilite.ir</span>
                <span>۰۲۱-۶۶۷۵۷۳۷۹</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
